import gql from "graphql-tag";
import React from "react";
import styled from "styled-components";
import { formatDateAgo } from "utils/formats";

import { FileExcelIcon } from "~/components/common/icons";
import { EmptyRow, Table } from "~/components/common/tables";
import { DataImportFragment } from "~/components/Settings/ImportHistory.generated";
import { fgColor } from "~/styles/mixins";

export const DATA_IMPORT_FRAGMENT = gql`
  fragment DataImport on SalesforceDataImport {
    id
    status
    vendor
    importedBy
    fileUrl
    fileName
    createdAt
  }
`;

export interface ImportHistoryProps {
  rows: readonly DataImportFragment[];
  loading: boolean;
}

/* eslint-disable-next-line react/prop-types */
const ImportHistory = ({ rows, loading }: ImportHistoryProps) => {
  return (
    <div className="table-overflow-wrapper entries-table-wrapper">
      <StyledTable>
        <thead>
          <tr>
            <th className="name-cell">File</th>
            <th className="other-cell">Vendor</th>
            <th className="other-cell">User</th>
            <th className="other-cell">Uploaded</th>
            <th className="other-cell">Status</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              <td className="name-cell">
                <div>
                  <Thumbnail as={FileExcelIcon} />
                  {row.fileUrl && <a href={row.fileUrl}>{row.fileName}</a>}
                  {!row.fileUrl && <div>{row.fileName}</div>}
                </div>
              </td>
              <td className="other-cell">
                <div>{row.vendor}</div>
              </td>
              <td className="other-cell">
                <div>{row.importedBy}</div>
              </td>
              <td className="other-cell">
                <div>{formatDateAgo(row.createdAt)}</div>
              </td>
              <td className="other-cell">
                <div>{row.status}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
      {!loading && !rows.length && <EmptyRow>No uploaded files.</EmptyRow>}
    </div>
  );
};

const Thumbnail = styled.span`
  ${fgColor.blue()};
  display: inline-block;
  flex: 0 0 2rem;
  vertical-align: middle;
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
  padding-right: 0.5rem;
`;

const StyledTable = styled(Table)`
  th {
    padding-left: 0.5rem;
  }
  td.name-cell {
    cursor: pointer;
    max-width: 20rem;
  }
  td.other-cell {
    width: 10rem;
  }
`;

export default ImportHistory;
